import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Footer from "./components/Footer";

export default function App() {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: false,
      mirror: false,
      offset: 120,
      delay: 0,
      easing: 'ease',
    });

    // Refresh to ensure all elements are detected on first load
    AOS.refresh();
  }, []);

  return (
    <div className="overflow-x-hidden">
      <Hero />
      <About />
      <Projects />
      <Skills />
      <Footer/>
    </div>
  );
}
